var $a60efb3893829878$exports = {};
$a60efb3893829878$exports = {
    "colorSwatchPicker": `Sz\xednt\xe1rak`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe1lasszon ki egy elemet`,
    "tableResizer": `\xc1tm\xe9retez\u{151}`
};


export {$a60efb3893829878$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
